document.addEventListener("DOMContentLoaded", function() {
    console.log("Custom JS file loaded!!!");
});


// REVIEW WIDGET CONTENT UPDATE START
setTimeout(() => {
  
  if(document.querySelector("span.yotpo-dropdown-option:nth-child(3)")){
    document.querySelector("span.yotpo-dropdown-option:nth-child(3)").innerHTML = "Verified purchase";
    //console.log("VERIFIED PURCHASED IS FOUND")
    }else{
      //console.log("VERIFIED PURCHASED IS NOT FOUND")
    }
}, 2000);



setTimeout(() => {
  // Select all children and grandchildren of the review container
  const reviewContainer = document.querySelectorAll("#yotpo-reviews-container > div > div");
  
  // Flag to track if the class is found
  let classFound = false;
  
  // Iterate through all elements to check if any have the 'yotpo-media-option-thumbnail' class
  reviewContainer.forEach(function(container) {
    if (container.querySelector('.yotpo-media-option-thumbnail')) {
      classFound = true;
        //console.log("classFound = true;");
    }else{
        //console.log("classFound = false;");
    }
  });
  
  // If no element has the class, hide the specific element
  if (!classFound) {
    const dropdownElement = document.querySelector("span.yotpo-dropdown-option:nth-child(2)");
    if (dropdownElement) {
      dropdownElement.style.display = "none";
        //console.log(" dropdownElement.style.display = none");
    }
  }
    //console.log("TEST");
    }, 2000);

// REVIEW WIDGET CONTENT END
// REVIEW WIDGET CONTENT END



// function yotpoProgress() {

//   const progressBar = document.querySelector(".yotpo-register-link")
//   const vipTierList = document.querySelector("#MainContent > div.yotpo-widget-loyalty-page > div > div:nth-child(2)")

//   if (progressBar) {
//       vipTierList.style.display = "none";
//       console.log("progressBar does not exist");
//   } else {
//       vipTierList.style.display = "block";  
//       console.log("progressBar exists");
//   }

// }

// function waitForElement(selector) {
//   return new Promise(function(resolve) {
//       const element = document.querySelector(selector);
//       if (element) {
//           return resolve(document.querySelectorAll(selector));
//       }
//       const observer = new MutationObserver(function(mutations) {
//           const foundElement = document.querySelector(selector);
//           if (foundElement) {
//               resolve(document.querySelectorAll(selector));
//               observer.disconnect();
//           }
//       });
//       observer.observe(document.body, { childList: true, subtree: true });
//   });
// }

// function init() {
//   waitForElement('.yotpo-register-link').then((elements) => {
//       if (elements.length > 0) {
//           yotpoProgress();
//           console.log("Found yotpoProgress function.");
//       } else {
//           console.log("yotpoProgress function is not found.");
//       }
//   });
// }

// init();

